player.incomeSourcesModule = {
    possibleIncomeSources: [],
    playerIncomeSources: false,
    playerUnsavedIncomeSources: false,
    possibleIncomeSourcesLang: false,
    incomeSourcesSelectBox: (data, isBetLimitModal, isFromUserSettings) => {
        return  `<a data-role="none" id="selectIncomeSources"
                    onmousedown="player.incomeSourcesModule.showIncomeSourcesSelectBoxModal(${isBetLimitModal}, ${isFromUserSettings});">
                    <div id="selectedIncomeSources">
                        ${data[0].length ? data[1]
                            .filter(possibleSourceID =>
                                data[0].includes(possibleSourceID.code)
                            )
                            .map((playerSourceID, sourceIndex) =>
                                `${playerSourceID.translation}${sourceIndex < data[0].length - 1 ? `<div class="pipe">&nbsp;</div>` : ''}`
                            )
                            .join('')
                            : `<span>${texts.IncomeSourcesSelectSource}</span>`
                        }
                        <span class="icon"></span>
                        <div class="mandatory-dot"></div>
                    </div>
                </a>`;
    },
    incomeSourcesToUserSettings: async () => {
        var data = await Promise.all([player.incomeSourcesModule.playerUnsavedIncomeSources ? player.incomeSourcesModule.playerUnsavedIncomeSources : player.incomeSourcesModule.obtainPlayerIncomeSources(), player.incomeSourcesModule.getPossibleIncomeSources()]);

        if (data[0] && data[1] && data[1].length) {
            var incomeSources = `
                <div class="label" id="incomeSourcesLabel">${texts.IncomeSourcesLabel}</div>
                ${player.incomeSourcesModule.incomeSourcesSelectBox(data, false, true)}
                <a id="saveIncomeSources" class="transparent-red-button" data-role="none" onmousedown="player.incomeSourcesModule.savePlayerIncomeSources();">
                    ${texts.IncomeSourcesSaveData}
                </a>
            `;
            document.querySelector("#incomeSources").innerHTML = incomeSources;
        }
    },
    showIncomeSourcesModal: async (isBetLimitModal, isFromNative) => {
        try {
            if ((stored.FreebetModalActive || stored.JackpotModalActive) || (rfs.jackpotModal && Object.keys(rfs.jackpotModal).length)) {
                rfs.IncomeSourcesModal = setInterval(function() {
                    clearInterval(rfs.IncomeSourcesModal);
                    delete rfs.IncomeSourcesModal;
                    // opakovane zaslat oba parametre napr pri zobrazeni jackpot modal pred zdrojmi prijmu, 
                    // aby sa ulozil aj cas posledneho zobrazenia cez shownIncomeSourcesPopup
                    player.incomeSourcesModule.showIncomeSourcesModal(isBetLimitModal, isFromNative);
                }, 2500);
                return false;
            }
            clearInterval(rfs.IncomeSourcesModal);
            delete rfs.IncomeSourcesModal;

            var data = await Promise.all([player.incomeSourcesModule.playerUnsavedIncomeSources ? player.incomeSourcesModule.playerUnsavedIncomeSources : player.incomeSourcesModule.obtainPlayerIncomeSources(), player.incomeSourcesModule.getPossibleIncomeSources()]);
            dialog.open({
                id: "showIncomeSourcesModal",
                backdropDismiss: false,
                persistent: false,
                autoClose: sets.ClosingTimeTimeout,
                parseJQM: false,
                closed: function () {  player.incomeSourcesModule.incomeSourcesToUserSettings(); },
                content: `
                            <div id="incomeSourcesModal" class="err-sevIncomeSources">
                                <span class="closeInfo">
                                    <div class="ui-icon ui-icon-info"></div>
                                </span>
                                <div class="ui-bar-e two-buttons">
                                    <h3 class="infoHeader info-modal-text" style="">${isBetLimitModal ? texts.IncomeSourcesLimitText.split('{0}')[0] + (profile.SourcesOfIncomeOverallTotalBetLimit + profile.Currency + texts.IncomeSourcesLimitText.split('{0}')[1]) : texts.IncomeSourcesNotFilledLabel}</h3>
                                    ${player.incomeSourcesModule.incomeSourcesSelectBox(data, isBetLimitModal, false)}
                                    <div class="legal-info info-modal-text" style="">${texts.IncomeSourcesLegalText}</div>
                                    <div class="button-group">
                                        <button class="ui-btn" data-theme="none" onmousedown="player.incomeSourcesModule.closeIncomeSourcesModal();">${texts.IncomeSourcesClose}</button>
                                        <button class="ui-btn saveIncomeSources" data-theme="none" onmousedown="player.incomeSourcesModule.savePlayerIncomeSources();">${texts.IncomeSourcesSave}</button>
                                    </div>
                                </div>
                            </div>
                        `
            });
            if (isFromNative) {
                result = await player.incomeSourcesModule.shownIncomeSourcesPopup();
                console.log("showIncomeSourcesModal result: " + result);
                main.createLog(2, "showIncomeSourcesModal_Sucess", "showIncomeSourcesModal result: " + result);
                return false;
            }
            return true;
        } catch (e) {
            main.createLog(2, "showIncomeSourcesModal_Failed", "error: " + e);
            return false;
        }
    },
    closeIncomeSourcesModal: () => {
        dialog.close('showIncomeSourcesModal');
        player.incomeSourcesModule.playerUnsavedIncomeSources = player.incomeSourcesModule.playerIncomeSources.slice();
        player.incomeSourcesModule.incomeSourcesToUserSettings();
    },
    showIncomeSourcesSelectBoxModal: async (isBetLimitModal, isFromUserSettings) => {
        var data = await Promise.all([player.incomeSourcesModule.playerUnsavedIncomeSources ? player.incomeSourcesModule.playerUnsavedIncomeSources : player.incomeSourcesModule.obtainPlayerIncomeSources(), player.incomeSourcesModule.getPossibleIncomeSources()]);
        if (data[0] && data[1] && data[1].length) {
            dialog.open({
                id: "showIncomeSourcesSelectBoxModal",
                backdropDismiss: false,
                persistent: false,
                autoClose: 200000,
                parseJQM: false,
                content: `
                    <div class="all-income-sources-modal err-sevIncomeSources">
                        <div class="all-income-sources-modal__content">
                        <div class="all-income-sources-modal__header">${texts.IncomeSourcesLabel}</div>
                        <div class="all-income-sources-modal__group">
                        ${data[1].map(source => `
                                                <div id="incomeSource${source.code}Wrapper"
                                                    class="all-income-sources-modal__checkbox custom-checkbox"
                                                    onmousedown="player.incomeSourcesModule.toggleIncomeSource(event)">
                                                    <div class="ui-checkbox">
                                                        <input type="checkbox"
                                                            id="incomeSource${source.code}"
                                                            data-code="${source.code}"
                                                            class="all-income-sources-modal__input"
                                                            ${data[0].includes(source.code) ? 'checked="checked"' : ''}
                                                            >
                                                    </div>
                                                    <label id="incomeSource${source.code}Label"
                                                        class="all-income-sources-modal__label">
                                                        ${source.translation}
                                                    </label>
                                                </div>
                                            `).join('')}
                                            </div>
                                            <div class="all-income-sources-modal__button-group">
                                                <button class="all-income-sources-modal__button" data-theme="none" onmousedown="player.incomeSourcesModule.closeIncomeSourcesSelectBoxModal();">${texts.IncomeSourcesClose}</button>
                                                <button class="all-income-sources-modal__button all-income-sources-modal__button--save" data-theme="none" onmousedown="player.incomeSourcesModule.changedPlayerIncomeSources(${isBetLimitModal}, ${isFromUserSettings}); dialog.close('showIncomeSourcesSelectBoxModal');">${texts.IncomeSourcesAccept}</button>
                                            </div>
                                        </div>
                                    </div>
                                        `
                                });
        } else {
            main.createLog(2, "showIncomeSourcesSelectBoxModal_Failed", "data[0]: " + data[0] + " data[1]: " + data[1]);
        }
    },
    toggleIncomeSource: event => {
        const checkbox = event.currentTarget.querySelector("input");
        checkbox.checked = !checkbox.checked;
    },
    getSelectedIncomeSources: () => [
        ...document.querySelectorAll(".all-income-sources-modal__group input:checked")
    ].map(input => input.dataset.code),
    closeIncomeSourcesSelectBoxModal: () => {
        dialog.close('showIncomeSourcesSelectBoxModal');
    },
    // Ziskanie moznych zdrojov prijmu pre modal pri betovani, modal po uplynuti doby, onboarding.
    getPossibleIncomeSources: async () => {
        try {
            if (player.incomeSourcesModule.possibleIncomeSources.length && player.incomeSourcesModule?.possibleIncomeSourcesLang === offer.lang) {
                return player.incomeSourcesModule.possibleIncomeSources;
            }
            var requestURL = `${url.centralSB}/onboarding/possible-sources-of-income?sportBoxID=${stored.SBID}&languageID=${offer.lang}`;
            const response = await fetch(requestURL);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            var jsonResponse = await response.json();
            player.incomeSourcesModule.possibleIncomeSources = jsonResponse.possibleSourcesOfIncome;
            player.incomeSourcesModule.possibleIncomeSourcesLang = offer.lang;
            return jsonResponse.possibleSourcesOfIncome;
        }
        catch (error) {
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.createLog(2, "getPossibleIncomeSources_Failed", "error: " + error + " URL: " + requestURL);
            return false;
        }
    },
    // Ulozenie zdrojov prijmu hraca pri betovani, modal po uplynuti doby, pre onboarding.
    changedPlayerIncomeSources: async (isBetLimitModal, noUpdateIncomeSourcesModal) => {
        try {
            if (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) {
                return false;
            }
            var selectedIncomeSources = player.incomeSourcesModule.getSelectedIncomeSources();
            if (!selectedIncomeSources || !Array.isArray(selectedIncomeSources) || selectedIncomeSources.length === 0) {
                modal.showErrObj(2, 5, {err1: texts.IncomeSourcesInsuficientSelected, errType: "changedPlayerIncomeSources"});
            }
            player.incomeSourcesModule.playerUnsavedIncomeSources = selectedIncomeSources;
            player.incomeSourcesModule.incomeSourcesToUserSettings();
            if (!noUpdateIncomeSourcesModal) {
                player.incomeSourcesModule.showIncomeSourcesModal(isBetLimitModal);
            }
        } catch (error) {
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.createLog(2, "getPossibleIncomeSources_Failed", "error: " + error);
        }
    },
    savePlayerIncomeSources: async () => {
        try {
            if (!player.incomeSourcesModule.playerUnsavedIncomeSources || !Array.isArray(player.incomeSourcesModule.playerUnsavedIncomeSources) || player.incomeSourcesModule.playerUnsavedIncomeSources.length === 0) {
                modal.showErrObj(2, 5, {err1: texts.IncomeSourcesInsuficientSelected, errType: "changedPlayerIncomeSources"});
                return false;
            }
            var data = {
                playerID: stored.PlayerID,
                sourceOfIncomeIDs: player.incomeSourcesModule.playerUnsavedIncomeSources,
                sportBoxID: stored.SBID
            };
            var requestURL = `${url.centralSB}/onboarding/save-sources-of-income`;
            var response = await fetch(requestURL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "*/*"
                },
                body: JSON.stringify(data)
            });

            if (!response || !response.ok) {
                var responseText = response && response.text ? await response.text() : "";
                throw {
                    requestUrl: requestURL,
                    responseText: responseText,
                    status: response && response.status,
                    statusText: response && response.statusText
                };
            }
            player.incomeSourcesModule.playerIncomeSources = player.incomeSourcesModule.playerUnsavedIncomeSources.slice();
            main.closeDialog(true);

            return true;

        } catch (fetchErr) {
            fetchErr = fetchErr || {};
            fetchErr.requestUrl = fetchErr.requestUrl || requestURL;
            // player.incomeSourcesModule.clearIncomeSources();
            // Neuspesne odoslanie, zobrazi chybocu hlasku
            modal.showErrObj(1, 5, { err1: texts.ConnectionErr, errType: "ConnectionErr" });
            main.createLog(2, "savePlayerIncomeSources_Failed", "# ERROR: " + JSON.stringify(fetchErr) + " # DATA: " + JSON.stringify(data));
            dialog.close();
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },
    shownIncomeSourcesPopup: async () => {
        try {
            if (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) {
                return false;
            }
            data = {
                playerID: stored.PlayerID,
                sportBoxID: stored.SBID
            };
            var requestURL = `${url.centralSB}/onboarding/sources-of-income-popup-shown`;
            var response = await fetch(requestURL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "*/*"
                },
                body: JSON.stringify(data)
            });

            if (!response || !response.ok) {
                var responseText = response && response.text ? await response.text() : "";
                throw {
                    requestUrl: requestURL,
                    responseText: responseText,
                    status: response && response.status,
                    statusText: response && response.statusText
                };
            }
            return true;
        } catch (fetchErr) {
            fetchErr = fetchErr || {};
            fetchErr.requestUrl = fetchErr.requestUrl || requestURL;
            player.incomeSourcesModule.clearIncomeSources();
            main.createLog(2, "shownIncomeSourcesPopup_Failed", "# ERROR: " + JSON.stringify(fetchErr) + " # DATA: " + JSON.stringify(data));
            // Neuspesne odoslanie, zobrazi chybocu hlasku
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },
    obtainPlayerIncomeSources: async () => {
        if (player.incomeSourcesModule.playerIncomeSources) {
            return player.incomeSourcesModule.playerIncomeSources;
        }
        const playerIncomeSources = await player.incomeSourcesModule.getPlayerIncomeSources();
        player.incomeSourcesModule.playerIncomeSources = playerIncomeSources.sourceOfIncomeIDs;
        await player.incomeSourcesModule.incomeSourcesToUserSettings();
        return player.incomeSourcesModule.playerIncomeSources;
    },
    // Ziskanie ulozenych zdrojov prijmu hraca
    getPlayerIncomeSources: async () => {
        var requestURL = "";
        try {
            if (!stored.PlayerID || stored.PlayerID === profile.ManualVerifiedPlayerID) {
                return false;
            }
            requestURL = `${url.centralSB}/onboarding/player-sources-of-income?playerID=${stored.PlayerID}&sportBoxID=${stored.SBID}`;
            const response = await fetch(requestURL);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            modal.showErrObj(1, 5, { err1: texts.ConnectionErr, errType: "ConnectionErr" });
            main.createLog(2, "getPlayerIncomeSources_Failed", "error: " + error + " URL: " + requestURL);
            console.error('getPlayerIncomeSources error:', error);
            return false;
        }
    },
    clearIncomeSources: () => {
        player.incomeSourcesModule.playerIncomeSources = false;
        player.incomeSourcesModule.playerUnsavedIncomeSources = false;
    }
}